var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg25({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.635735 32.5C0.635735 50.3743 15.1257 64.8643 33 64.8643C50.8743 64.8643 65.3643 50.3743 65.3643 32.5C65.3643 14.6257 50.8743 0.135742 33 0.135742C15.1257 0.135742 0.635735 14.6257 0.635735 32.5ZM51.7348 32.5C51.7348 42.8469 43.3469 51.2348 33 51.2348C22.6531 51.2348 14.2652 42.8469 14.2652 32.5C14.2652 22.1531 22.6531 13.7652 33 13.7652C43.3469 13.7652 51.7348 22.1531 51.7348 32.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 0.135742C37.2501 0.135742 41.4587 0.972869 45.3853 2.59933C49.3119 4.22578 52.8797 6.60972 55.885 9.61502C58.8903 12.6203 61.2742 16.1881 62.9007 20.1147C64.5271 24.0414 65.3643 28.2499 65.3643 32.5H51.7348C51.7348 30.0397 51.2502 27.6035 50.3087 25.3305C49.3671 23.0575 47.9872 20.9922 46.2475 19.2525C44.5078 17.5128 42.4425 16.1329 40.1695 15.1913C37.8965 14.2498 35.4603 13.7652 33 13.7652V0.135742Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25);
export default __webpack_public_path__ + "static/media/25.2ca9ce2a4ac2a98ca7a95a3dba1508c3.svg";
export { ForwardRef as ReactComponent };